import { render, staticRenderFns } from "./AllCampaignStatistics.vue?vue&type=template&id=50a27e26&"
import script from "./AllCampaignStatistics.vue?vue&type=script&lang=ts&"
export * from "./AllCampaignStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./AllCampaignStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VHover,VRow})
